import type { ReactNode } from 'react'
import styles from '@/styles/components/tpsm/TpsmNavTabs.module.scss'

export type AdminNavTabItem = {
  key: string
  label: string
  icon: ReactNode
}

export interface AdminNavTabsProps {
  items: AdminNavTabItem[]
  activeKey: string
  onChange: (key: string) => void
  /** `aria-label` for the tablist (default: Admin sections). */
  ariaLabel?: string
}

/**
 * Admin Users / Permissions tabs — same visual language as TPSM section tabs (bordered bar, icon + label).
 */
export function AdminNavTabs({ items, activeKey, onChange, ariaLabel = 'Admin sections' }: AdminNavTabsProps) {
  return (
    <nav className={styles.root} aria-label={ariaLabel}>
      <div className={styles.track} role="tablist">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={activeKey === item.key}
            className={`${styles.tab} ${activeKey === item.key ? styles.tabActive : ''}`.trim()}
            onClick={() => onChange(item.key)}
          >
            <span className={styles.tabIcon}>{item.icon}</span>
            <span className={styles.tabLabel}>{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  )
}
